import React, { Component } from "react"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { IJobDocument, IUIUser, IUIUserSearch } from "../../../../models"
import { FloatingActionButton, CircularProgress, Toggle } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../../../components/layout/TableActionBar"
import JobEmployeesTable from "./JobEmployeesTable"
import AppStateStore from "../../../../stores/AppStateStore"
import AddEmployeeDialogForChip from "../../../../components/employee/AddEmployeeDialogForChip"
import * as api from "../../../../api"
import { grey600 } from "material-ui/styles/colors"
import ToolTip from "react-portal-tooltip"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"
import AccountStore from "../../../../stores/AccountStore"

interface IProps {
    readonly: boolean
    job: IJobDocument
    reloadJob: () => void
}

interface IState {
    showDefaultJobEmployees: boolean
    showAssignedEmployees: boolean
    showFloatEmployees: boolean
    employees: IUIUser[]
    selectedEmployees: IUIUser[]
    openAddEmployeeDialog: boolean
    loading: boolean
    total: number
    offset: number
    limit: number
}

export default class JobDetailsAssignedEmployees extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            showDefaultJobEmployees: true,
            showAssignedEmployees: false,
            showFloatEmployees: false,
            employees: [],
            selectedEmployees: [],
            openAddEmployeeDialog: false,
            loading: false,
            total: 0,
            offset: 0,
            limit: 20,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getEmployees()
    }

    async getEmployees() {
        this.setState({ loading: true })
        const response = await api.getJobEmployees(this.props.job.Id, this.state.showDefaultJobEmployees, this.state.showAssignedEmployees, this.state.showFloatEmployees, this.state.offset / this.state.limit, this.state.limit)
        const result = response.data as IUIUserSearch
        this.setState({
            loading: false,
            total: result.TotalDocumentCount,
            employees: result.Documents,
            selectedEmployees: []
        })
    }

    assignEmployees(employees: IUIUser[]) {
        (this.props.job.AssignedEmployees || [])
            .filter(i => !i.Unassigned)
            .map(i => i.Id)
            .find(i => employees.find(j => j.Id === i) ? true : false) ?
            AppStateStore.setAlertDialogContent({
                content: strings.Employee_already_assigned_to_this_job
            }) :
            this.setState({ loading: true, openAddEmployeeDialog: false }, () => {
                api.addAssignedEmployees(this.props.job.Id, employees.map(i => i.Id))
                    .then((res) => {
                        this.getEmployees()
                        this.props.reloadJob()
                    })
                    .catch((err) => {
                        AppStateStore.setProgressSnackbarContent(err.data.message)
                        this.setState({ loading: false })
                    })
            })
    }

    render() {
        return (
            <div className="detail-tab" style={{ position: "relative" }}>
                {!this.props.readonly && (
                    <FloatingActionButton data-intercom-target={"menu-Jobs-JobDetails-AssignedEmployees-Btn-Add"} style={{ position: "absolute", right: 50, top: -15 }} secondary onTouchTap={() => this.setState({ openAddEmployeeDialog: true })}>
                        <ContentAdd />
                    </FloatingActionButton>
                )}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingLeft: 35, fontSize: 25, fontWeight: "bold", marginTop: 15 }}>{strings.Employees}</div>
                    <div style={{ marginTop: 10 }}>
                        <Toggle
                            data-intercom-target={"job-AssignedEmployee-Toggle-ShowDefaultJobEmployees"}
                            toggled={this.state.showDefaultJobEmployees}
                            onToggle={(e, value) => {
                                this.setState({ showDefaultJobEmployees: value, showAssignedEmployees: false, showFloatEmployees: false }, () => this.getEmployees())
                            }}
                            labelPosition="left"
                            label={checkJobFieldAvailable('plural') ? `Show Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Employees` :  strings.Show_Default_Job_Employees}
                            style={{ maxWidth: 300, marginBottom: 3 }}
                        />
                        <Toggle
                            data-intercom-target={"job-AssignedEmployee-Toggle-ShowAssignedEmployees"}
                            toggled={this.state.showAssignedEmployees}
                            onToggle={(e, value) => {
                                this.setState({ showDefaultJobEmployees: false, showAssignedEmployees: value, showFloatEmployees: false }, () => this.getEmployees())
                            }}
                            labelPosition="left"
                            label={strings.Show_Assigned_Employees}
                            style={{ maxWidth: 300, marginBottom: 3 }}
                        />
                        <Toggle
                            data-intercom-target={"job-AssignedEmployee-Toggle-ShowFloatEmployees"}
                            toggled={this.state.showFloatEmployees}
                            onToggle={(e, value) => {
                                this.setState({ showDefaultJobEmployees: false, showAssignedEmployees: false, showFloatEmployees: value }, () => this.getEmployees())
                            }}
                            labelPosition="left"
                            label={
                                <div style={{ display: "flex" }}>
                                    <span>{strings.Show_Float_Employees}</span>
                                    <FloatEmployeeInfoIcon />
                                </div>
                            }
                            style={{ maxWidth: 300 }}
                        />
                    </div>
                </div>
                <TableActionBar
                    rowSelectionCount={this.state.selectedEmployees.length}
                    singleSelectedMessage={strings.Employee_Selected}
                    multipleSelectedMessage={strings.x_Employees_Selected}
                    searchText={""}
                    onDeleteClick={() => {
                        AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_unassign_employee,
                            confirm: () => {
                                this.setState({ loading: true }, () => {
                                    api.unAssignEmployees(this.props.job.Id, this.state.selectedEmployees.map(item => item.Id))
                                        .then((res) => {
                                            AppStateStore.setProgressSnackbarContent(strings.Successfully_unassigned)
                                            this.getEmployees()
                                            this.props.reloadJob()
                                        })
                                        .catch((err) => {
                                            AppStateStore.setProgressSnackbarContent(err.data.message)
                                            this.setState({ loading: false })
                                        })
                                })
                            }
                        })
                    }}
                    readonly={this.props.readonly}
                />
                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    this.state.employees.length === 0 ?
                        <div>
                            <h2 style={{ textAlign: "center", marginTop: 25 }}>{strings.No_employee_found}</h2>
                        </div> :
                        <JobEmployeesTable
                            readonly={this.props.readonly || this.state.showDefaultJobEmployees || this.state.showFloatEmployees}
                            employees={this.state.employees}
                            selectedEmployees={this.state.selectedEmployees}
                            total={this.state.total}
                            offset={this.state.offset}
                            limit={this.state.limit}
                            limitOptions={[20, 50, 100]}
                            onPageClick={offset => this.setState({ offset }, () => this.getEmployees())}
                            onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getEmployees())}
                            handleSelectEmployees={selectedEmployees => {
                                this.setState({ selectedEmployees })
                            }}
                        />
                }
                {this.state.openAddEmployeeDialog &&
                    <AddEmployeeDialogForChip
                        handleClose={() => this.setState({ openAddEmployeeDialog: false })}
                        open={this.state.openAddEmployeeDialog}
                        handleAddEmployees={this.assignEmployees}
                        filterByLevel={false}
                        jobId={this.props.job.Id}
                    />
                }
            </div>
        )
    }
}

interface IFloatEmployeeInfoIconProps {

}
interface IFloatEmployeeInfoIconState {
    open: boolean
}
class FloatEmployeeInfoIcon extends React.Component<IFloatEmployeeInfoIconProps, IFloatEmployeeInfoIconState>  {
    private iconKeyStr = "FloatEmployeeInfoIcon"
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{ zIndex: 100 }}>
                <ToolTip
                    active={this.state.open}
                    position="bottom"
                    arrow="center"
                    parent={"#" + this.iconKeyStr}
                    tooltipTimeout={50}
                >
                    {strings.Float_Employee_Info}
                </ToolTip>
                <i
                    id={this.iconKeyStr}
                    className="fa fa-info-circle"
                    style={{ fontSize: 12, position: "absolute", color: grey600 }}
                    onMouseOver={() => this.setState({ open: true })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
